import React from "react";

type TabButtonProps = {
  buttonId: string;
  activeButton: string;
  onClick: () => void;
  children: React.ReactNode;
};

const TabButton: React.FC<TabButtonProps> = ({
  buttonId,
  activeButton,
  onClick,
  children,
}) => {
  return (
    <button
      className={`nav-link ${activeButton === buttonId ? "active" : ""}`}
      id={buttonId}
      data-bs-toggle="pill"
      data-bs-target={`#v-pills-${buttonId}`}
      type="button"
      role="tab"
      aria-controls={`v-pills-${buttonId}`}
      aria-selected={activeButton === buttonId}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default TabButton;
